import Vue from 'vue'
// 组件
import EdCard from './package/EdCard'
import EdDate from './package/EdDate'
import EdFlow from './package/EdFlow'
import EdForm from './package/EdForm'
import EdLink from './package/EdLink'
import EdIcons from './package/EdIcons'
import EdImage from './package/EdImage'
import EdLabel from './package/EdLabel'
import EdTable from './package/EdTable'
import EdDialog from './package/EdDialog'
import EdDrawer from './package/EdDrawer'
import EdUpload from './package/EdUpload'
import EdViewer from './package/EdViewer'
import EdInputMap from './package/EdInputMap'
import EdInputPop from './package/EdInputPop'
import ExtendSlot from './package/ExtendSlot'
import OptionSlot from './package/OptionSlot'
import EdCodeEditor from './package/EdCodeEditor'
import EdInputArray from './package/EdInputArray'
import EdInputColor from './package/EdInputColor'
import EdInputTable from './package/EdInputTable'
import EdJsonEditor from './package/EdJsonEditor'
import EdJsonViewer from './package/EdJsonViewer'
import EdMarkEditor from './package/EdMarkEditor'
import EdTreeSelect from './package/EdTreeSelect'
import EdWangEditor from './package/EdWangEditor'
import EdTableEditor from './package/EdTableEditor'
import EdDescriptions from './package/EdDescriptions'

// 自定义插件
import print from './plugin/print'
import Message from './plugin/Message'

const components = [
  EdCard,
  EdDate,
  EdFlow,
  EdForm,
  EdLink,
  EdIcons,
  EdImage,
  EdLabel,
  EdTable,
  EdDialog,
  EdDrawer,
  EdUpload,
  EdViewer,
  EdInputMap,
  EdInputPop,
  ExtendSlot,
  OptionSlot,
  EdCodeEditor,
  EdInputArray,
  EdInputColor,
  EdInputTable,
  EdJsonEditor,
  EdJsonViewer,
  EdMarkEditor,
  EdTreeSelect,
  EdWangEditor,
  EdTableEditor,
  EdDescriptions
]
components.forEach(component => {
  Vue.component(component.name, component)
})

const install = function (Vue, opts = {}) {
    Vue.prototype.$EdBaseVue = opts
    Vue.prototype.$print = print;
    Vue.prototype.$msgExtra = Message;
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default {
    version: '1.0.0',
    install,
}
